import { CHANNELS } from '../constants/channels';
import { REPORT_REQUEST_PAYLOAD } from '../constants/payload';
import { REPORT_TYPE } from '../constants/report_type';

/**
 * Computes the appropriate payloads based on the given parameters.
 */
export const computeRequestPayloads = (payload, snapshots, nonAggregatedFlags, marketplaces) => {
  let requestPayloads = [];
  const { channel } = payload;
  for (let snapshot of snapshots) {
    if (payload.report.toUpperCase() === REPORT_TYPE.PL && channel === CHANNELS.ALL) {
      const channels = Object.values(CHANNELS);
      const payloadsByChannel = channels.map((c) => {
        return { ...payload, snapshot, channel: c };
      });
      requestPayloads.push(...payloadsByChannel);
    } else {
      const derivedPayload = { ...payload, snapshot };
      requestPayloads.push(derivedPayload);
    }
  }

  let nonAggregatedItems = {};
  for (let iter = 0; iter < requestPayloads.length; iter++) {
    nonAggregatedItems[iter] = getPayloadsWithNonAggregateFields(requestPayloads[iter], nonAggregatedFlags, marketplaces);
  }
  return [].concat.apply([], Object.keys(nonAggregatedItems)
                                   .map(function(key) {
                                     return nonAggregatedItems[key];
                                   }));
};

const getPayloadsWithNonAggregateFields = (payload, nonAggregatedFlags, marketplaces) => {
  const nonAggregatedItems = getNonAggregatedItems(payload, nonAggregatedFlags, marketplaces);
  if (!nonAggregatedItems) {
    return [payload];
  }
  const nonAggregatedFieldTuples = createTuples(nonAggregatedItems);

  return nonAggregatedFieldTuples.map((tuple) => {
    return { ...payload, ...tuple };
  });
};

const getNonAggregatedItems = (payload, nonAggregatedFlags, marketplaces) => {
  const nonAggregatedFields = getNonAggregatedFields(nonAggregatedFlags, payload);
  // check if all marketplace selected
  if (payload.marketplace.split(",").includes("0")) {
    return { [REPORT_REQUEST_PAYLOAD.MARKETPLACE]: marketplaces && marketplaces.filter(mp => mp.enabled).map(mp => mp.id) };
  }

  if (!nonAggregatedFields || !nonAggregatedFields.length) {
    return null;
  }

  return nonAggregatedFields
    .map((field) => {
      return { [field]: payload[field].split(',') };
    })
    .reduce((acc, item) => {
      const key = Object.keys(item)[0];
      acc[key] = item[key];
      return acc;
    }, {});
};

export const getNonAggregatedFields = (nonAggregatedFlags) => {

  const nonAggregatedFields = [];
  if (!nonAggregatedFlags.aggregatedMarketplaceSelected) {
    nonAggregatedFields.push(REPORT_REQUEST_PAYLOAD.MARKETPLACE);
  }

  if (!nonAggregatedFlags.aggregatedTimeFrameSelected) {
    nonAggregatedFields.push(REPORT_REQUEST_PAYLOAD.TIMEFRAME);
  }

  if (!nonAggregatedFlags.aggregatedProductLineSelected) {
    nonAggregatedFields.push(REPORT_REQUEST_PAYLOAD.PRODUCTLINES);
  }

  return nonAggregatedFields;
};

export const getNonAggregatedFieldsWithMultiValues = (payloads,
             payloadFields = [REPORT_REQUEST_PAYLOAD.MARKETPLACE, REPORT_REQUEST_PAYLOAD.TIMEFRAME, REPORT_REQUEST_PAYLOAD.PRODUCTLINES]) => {
  return payloadFields.filter((f) => {
    const values = payloads.map((p) => p[f]);    
    return [...new Set(values)].length > 1;
  });
};

const createTuples = (items) => {
  return Object.keys(items)
    .map((key) => createKeyValueTuple(key, items[key]))
    .reduce((accumulator, item) => {
      if (!accumulator || !accumulator.length) {
        return item;
      }
      return accumulator
        .map((a) => {
          return item.map((k) => {
            return { ...k, ...a };
          });
        })
        .flat();
    }, []);
};

const createKeyValueTuple = (key, values) => {
  return values.map((v) => {
    return { [key]: v };
  });
};



// WEBPACK FOOTER //
// ./src/utils/payload.js